<script>
  import Icon from '@iconify/svelte';
  import Flash from './Flash.svelte';
  import { nextInkSeed } from '../lib/ink.js';

  let { title, children } = $props();

  const seed = nextInkSeed();
</script>

<svelte:head><title>{title} · neosocialmix</title></svelte:head>

<div class="min-h-screen flex items-center justify-center px-6 py-12">
  <div class="w-full max-w-sm">
    <div class="flex items-center justify-center gap-2 mb-8 text-primary-900 font-display text-2xl tracking-tight">
      <Icon icon="mdi:stamper" class="text-primary-700" />
      neosocialmix
    </div>
    <!-- Deckle all four corners at uneven sizes: handmade card stock, no two
         edges alike. -->
    <div
      class="card-elevated rotate-[-0.5deg]"
      data-augmented-ui="tl-deckle tr-deckle br-deckle bl-deckle"
      data-ink-seed={seed}
      style="--aug-tl: 30px; --aug-tr: 24px; --aug-br: 34px; --aug-bl: 26px"
    >
      <h1 class="text-hierarchy-3 mb-6 text-center">{title}</h1>
      <Flash />
      {@render children?.()}
    </div>
  </div>
</div>
